// resume helper functions for getting and updating nested properties by path - used in resume editor

export function updateByPath(obj: any, path: string, value: any) {
  const keys = path.split(".");
  const newObj = structuredClone(obj);
  let current = newObj;

  for (let i = 0; i < keys.length - 1; i++) {
    const key = keys[i];
    const index = Number(key);

    if (!Number.isNaN(index)) {
      if (!Array.isArray(current)) throw new Error("Expected array in path");
      current[index] = structuredClone(current[index] || {});
      current = current[index];
    } else {
      if (Array.isArray(current[key])) {
        current[key] = [...current[key]];
      } else {
        current[key] = current[key] ? structuredClone(current[key]) : {};
      }
      current = current[key];
    }
  }

  const lastKey = keys.at(-1)!;
  const lastIndex = Number(lastKey);

  if (!Number.isNaN(lastIndex) && Array.isArray(current)) {
    current[lastIndex] = value;
  } else {
    current[lastKey] = value;
  }

  return newObj;
}

export function getByPath(obj: any, path: string) {
  return path.split(".").reduce((acc, key) => {
    const index = Number(key);
    return !Number.isNaN(index) ? acc?.[index] : acc?.[key];
  }, obj);
}
